<template>
	<div>
		<b-modal
			ref="corral-selector-modal-chickens"
			@hidden="$emit('hidden')"
			:title="`CAMBIAR CORRAL A ${chickenSelected.correlative}`"
			no-close-on-backdrop
			cancel-title="Cancelar"
			size="md"
		>
			<ValidationObserver ref="form">
				<b-row>
					<b-col class="input-select-corral" cols="12">
						<b-form-group id="input-group-1" label="Elegir corral de destino:" label-for="input-1">
							<ValidationProvider rules="required" v-slot="{ errors }">
								<v-select
									v-model="corral_id"
									:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
									:options="corrals"
									:clearable="false"
									label="full_name"
									:reduce="(option) => option.id"
									:class="{ 'border-danger rounded': errors[0] }"
								>
									<template v-slot:option="option">
										<div class="d-flex justify-content-between align-items-center">
											<span>{{ option.full_name }}</span>
										</div>
									</template>
								</v-select>
								<span v-if="errors[0]" class="text-danger">{{ errors[0] }}</span>
							</ValidationProvider>
						</b-form-group>
					</b-col>
				</b-row>
			</ValidationObserver>
			<template #modal-footer>
				<b-button @click="$emit('hidden')" v-if="!loading" variant="secondary">Cancelar</b-button>
				<b-button variant="secondary" disabled v-else>
					<b-spinner small />
					Cargando...
				</b-button>
				<b-button variant="outline-primary" @click="save" v-if="!loading">Guardar</b-button>
				<b-button variant="outline-primary" disabled v-else>
					<b-spinner small />
					Cargando...
				</b-button>
			</template>
		</b-modal>
	</div>
</template>

<script>
import modalMixin from "@/mixins/modal.js"
import corralService from "@/services/encaste/corral.service"

export default {
	name: "CorralSelectorModal",
	components: {},
	mixins: [modalMixin],
	props: {
		chickenSelected: Object,
	},
	async mounted() {
		this.isPreloading()
		await this.getActiveCorrals()
		this.toggleModal("corral-selector-modal-chickens")
		this.isPreloading(false)
	},
	computed: {},
	data() {
		return {
			corral_id: null,
			loading: false,
			corrals: [],
		}
	},
	methods: {
		async getActiveCorrals() {
			try {
				const { data } = await corralService.getActiveCorrals()
				this.corrals = data.map((corral) => ({
					...corral,
					full_name: `${corral.code} - ${corral.alias}`,
				}))
				this.corrals = this.corrals.filter((corral) => corral.id != this.chickenSelected.corral.id)
			} catch (error) {
				console.log(error)
			}
		},
		async save() {
			try {
				if (!(await this.$refs.form.validate())) {
					this.showToast("danger", "top-right", "Error", "AlertCircleIcon", "Complete los campos")
					return
				}
				const corral_name = this.corrals.find((corral) => corral.id == this.corral_id).full_name
				const { isConfirmed } = await this.showConfirmSwal({
					title: "¿Estás seguro de cambiar corrales?",
					html: `
								<div>
								<p><strong>Origen:</strong> ${this.chickenSelected.corral.code} - ${this.chickenSelected.corral.alias}</p>
								<p><strong>Destino:</strong> ${corral_name}</p>
								</div>
							`,
				})

				if (!isConfirmed) return
				this.isPreloading()
				await corralService.changeCorralChicks({
					chicks: [
						{
							id: this.chickenSelected.id,
							new_corral_id: this.corral_id,
						},
					],
				})
				this.$emit("refresh")
				this.showToast(
					"success",
					"top-right",
					"Corrales",
					"CheckIcon",
					"El cambio de corrales se realizo correctamente"
				)
				this.$emit("hidden")
			} catch (error) {
				this.showToast("danger", "top-right", "Corrales", "AlertCircleIcon", error.message)
			} finally {
				this.isPreloading(false)
			}
		},
	},
}
</script>

<style lang="scss" scoped></style>
